<template>
  <b-container fluid>
    <b-row>
      <b-col cols="12">
        <b-tabs>
          <b-tab title="Training">
            <TrainingTab />
          </b-tab>
          <b-tab title="Policies">
            <PoliciesTab />
          </b-tab>
        </b-tabs>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import TrainingTab from "./training.vue";
import PoliciesTab from "./policies.vue";
export default {
  name: "healthAndSafetyDashboard",
  components: {
    TrainingTab,
    PoliciesTab,
  },
};
</script>

<style>
</style>